import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export const StudentsDoughnut = ({ labels, dataset, onSegmentClick }) => {
  const data = {
    labels: labels, // Example: ["Males", "Females", "Unspecified"]
    datasets: [
      {
        data: dataset, // Example: [40, 60, 20]
        backgroundColor: ["#6F2E8F", "#fdb714", "#aaa"],
        hoverBackgroundColor: ["#6F2E8F", "#fdb714", "#aaa"],
        borderWidth: 0, // no border
        cutout: "70%", // controls thickness (higher = thinner)
      },
    ],
  };

  const options = {
    responsive: true,
    onClick: (event, elements, chart) => {
      if (elements.length > 0) {
        const clickedElement = elements[0];
        const index = clickedElement.index;
        const label = chart.data.labels[index];
        // const value = chart.data.datasets[0].data[index];

        // Call the callback function with the clicked segment data
        if (onSegmentClick) {
          onSegmentClick('gender', label);
        }
      }
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true, // use dot instead of box
          pointStyle: "circle", // small circle
          padding: 20,
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${context.label}: ${context.parsed} students`;
          }
        }
      }
    },
  };

  return <Doughnut data={data} options={options} />;
};
